import { type Dispatch, type SetStateAction, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import type {
  FlowLoadErrors,
  RunSmartConnectorFlowLoad,
  RunSmartConnectorReturnScope,
  SmartConnector,
} from 'pages/SmartConnectors/types';
import {
  StyledAddReturnScopeButton,
  StyledBottomButtons,
  StyledReturnScopeList,
} from '../../styles';
import { Section } from '../Section';
import { ScopeSettings } from './ScopeSettings';

export const ReturnScopes: FC<{
  loadId?: string;
  smartConnectorToRun: SmartConnector;
  returnScopes: RunSmartConnectorReturnScope[];
  onChange: Dispatch<SetStateAction<RunSmartConnectorFlowLoad>>;
  showError: boolean;
  errors: FlowLoadErrors['return_scopes'];
  resetError: (
    patch:
      | Partial<FlowLoadErrors>
      | ((prev: FlowLoadErrors) => Partial<FlowLoadErrors>)
  ) => void;
}> = ({
  loadId,
  smartConnectorToRun,
  returnScopes,
  onChange,
  showError,
  errors,
  resetError,
}) => {
  const { t } = useTranslation();

  const onAddReturnScope = () => {
    onChange((prev) => {
      const nextReturnScopes = [
        ...(prev.return_scopes || []),
        {
          source: '',
          name: '',
        },
      ];
      resetError((prev) => {
        return {
          ...prev,
          return_scopes: prev.return_scopes || [],
        };
      });
      return {
        ...prev,
        return_scopes: nextReturnScopes,
      };
    });
  };

  const hasEmptySource = returnScopes.some((scope) => !scope.source);

  return (
    <Section title={t('Return Scopes')}>
      <StyledReturnScopeList>
        {returnScopes.map((scope, i) => (
          <ScopeSettings
            loadId={loadId}
            key={`${scope.source}_${i}`}
            {...scope}
            index={i}
            smartConnectorToRun={smartConnectorToRun}
            onChange={onChange}
            showError={showError}
            errors={errors}
            resetError={resetError}
          />
        ))}
      </StyledReturnScopeList>
      <StyledBottomButtons>
        <StyledAddReturnScopeButton
          variant="text"
          onClick={onAddReturnScope}
          disabled={hasEmptySource}
        >
          {t('+  Add Scope')}
        </StyledAddReturnScopeButton>
      </StyledBottomButtons>
    </Section>
  );
};
